module.exports = __webpack_public_path__ + "img/libertad.cb5f76b5.jpg";